{
    "13": {
        "type": "zone",
        "key": 13,
        "position": {
            "x": 5,
            "y": 7,
            "z": 1
        },
        "level": 1
    },
    "14": {
        "type": "zone",
        "key": 14,
        "position": {
            "x": 6,
            "y": 7,
            "z": 1
        },
        "level": 1
    },
    "17": {
        "type": "zone",
        "key": 17,
        "position": {
            "x": 5,
            "y": 12,
            "z": 1
        },
        "level": 1
    },
    "18": {
        "type": "zone",
        "key": 18,
        "position": {
            "x": 6,
            "y": 12,
            "z": 1
        },
        "level": 1
    },
    "21": {
        "type": "zone",
        "key": 21,
        "position": {
            "x": 8,
            "y": 14,
            "z": 1
        },
        "level": 1
    },
    "22": {
        "type": "zone",
        "key": 22,
        "position": {
            "x": 9,
            "y": 14,
            "z": 1
        },
        "level": 1
    },
    "23": {
        "type": "zone",
        "key": 23,
        "position": {
            "x": 9,
            "y": 13,
            "z": 1
        },
        "level": 1
    },
    "24": {
        "type": "zone",
        "key": 24,
        "position": {
            "x": 8,
            "y": 15,
            "z": 1
        },
        "level": 1
    },
    "25": {
        "type": "zone",
        "key": 25,
        "position": {
            "x": 14,
            "y": 16,
            "z": 1
        },
        "level": 1
    },
    "27": {
        "type": "zone",
        "key": 27,
        "position": {
            "x": 15,
            "y": 16,
            "z": 1
        },
        "level": 1
    },
    "28": {
        "type": "zone",
        "key": 28,
        "position": {
            "x": 14,
            "y": 17,
            "z": 1
        },
        "level": 1
    },
    "29": {
        "type": "zone",
        "key": 29,
        "position": {
            "x": 18,
            "y": 15,
            "z": 1
        },
        "level": 1
    },
    "30": {
        "type": "zone",
        "key": 30,
        "position": {
            "x": 19,
            "y": 15,
            "z": 1
        },
        "level": 1
    },
    "31": {
        "type": "zone",
        "key": 31,
        "position": {
            "x": 19,
            "y": 16,
            "z": 1
        },
        "level": 1
    },
    "32": {
        "type": "zone",
        "key": 32,
        "position": {
            "x": 18,
            "y": 16,
            "z": 1
        },
        "level": 1
    },
    "33": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "spear",
        "name": "Speardevil",
        "key": 33,
        "position": {
            "x": 5,
            "y": 5,
            "z": 1
        },
        "level": 1
    },
    "34": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "spear",
        "name": "Speardevil",
        "key": 34,
        "position": {
            "x": 6,
            "y": 4,
            "z": 1
        },
        "level": 1
    },
    "36": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "spear",
        "name": "Hell's Bow",
        "key": 36,
        "position": {
            "x": 3,
            "y": 9,
            "z": 1
        },
        "level": 1
    },
    "37": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "spear",
        "name": "Speardevil",
        "key": 37,
        "position": {
            "x": 6,
            "y": 10,
            "z": 1
        },
        "level": 1
    },
    "38": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "sword",
        "name": "Daggerimp",
        "key": 38,
        "position": {
            "x": 4,
            "y": 10,
            "z": 1
        },
        "level": 1,
        "health": "10",
        "maxhealth": "10"
    },
    "39": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "jobKey": "dagger",
        "name": "Bladefiend",
        "key": 39,
        "position": {
            "x": 7,
            "y": 9,
            "z": 1
        },
        "level": 1
    },
    "40": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 40,
        "position": {
            "x": 5,
            "y": 13,
            "z": 1
        },
        "level": 1
    },
    "41": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 41,
        "position": {
            "x": 5,
            "y": 15,
            "z": 1
        },
        "level": 1
    },
    "43": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 43,
        "position": {
            "x": 6,
            "y": 14,
            "z": 1
        },
        "level": 1
    },
    "44": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 44,
        "position": {
            "x": 8,
            "y": 17,
            "z": 1
        },
        "level": 1
    },
    "45": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 45,
        "position": {
            "x": 10,
            "y": 17,
            "z": 1
        },
        "level": 1
    },
    "47": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 47,
        "position": {
            "x": 13,
            "y": 14,
            "z": 1
        },
        "level": 1
    },
    "48": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 48,
        "position": {
            "x": 11,
            "y": 16,
            "z": 1
        },
        "level": 1
    },
    "49": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 49,
        "position": {
            "x": 10,
            "y": 15,
            "z": 1
        },
        "level": 1
    },
    "50": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 50,
        "position": {
            "x": 12,
            "y": 18,
            "z": 1
        },
        "level": 1
    },
    "51": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 51,
        "position": {
            "x": 16,
            "y": 17,
            "z": 1
        },
        "level": 1
    },
    "52": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 52,
        "position": {
            "x": 17,
            "y": 18,
            "z": 1
        },
        "level": 1
    },
    "53": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 53,
        "position": {
            "x": 15,
            "y": 19,
            "z": 1
        },
        "level": 1
    },
    "54": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 54,
        "position": {
            "x": 17,
            "y": 19,
            "z": 1
        },
        "level": 1
    },
    "55": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 55,
        "position": {
            "x": 17,
            "y": 14,
            "z": 1
        },
        "level": 1
    },
    "56": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 56,
        "position": {
            "x": 21,
            "y": 15,
            "z": 1
        },
        "level": 1
    },
    "57": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 57,
        "position": {
            "x": 19,
            "y": 13,
            "z": 1
        },
        "level": 1
    },
    "58": {
        "affiliation": "bad",
        "bodyKey": "imp",
        "faceKey": "imp",
        "randomJobKey": "sword,spear,hammer,dagger,bow,sword,spear,hammer,dagger,bow,swordknight,spearknight,hammerknight,swordcavalier,spearcavalier,hammercavalier",
        "key": 58,
        "position": {
            "x": 20,
            "y": 17,
            "z": 1
        },
        "level": 1
    },
    "77": {
        "type": "zone",
        "key": 77,
        "position": {
            "x": 15,
            "y": 17,
            "z": 1
        },
        "level": 1
    },
    "swordlord": {
        "key": "swordlord",
        "position": {
            "x": 7,
            "y": 3,
            "z": 1
        },
        "level": 1
    },
    "archdevil": {
        "affiliation": "bad",
        "bodyKey": "devil",
        "faceKey": "devil",
        "key": "archdevil",
        "maxhealth": 30,
        "randomJobKey": "swordknight,spearknight,hammerknight",
        "position": {
            "x": 20,
            "y": 13,
            "z": 1
        },
        "level": 1
    },
    "highpriest": {
        "affiliation": "none",
        "key": "highpriest",
        "position": {
            "x": 16,
            "y": 19,
            "z": 1
        },
        "level": 1
    },
    "spearknight": {
        "affiliation": "none",
        "key": "spearknight",
        "position": {
            "x": 8,
            "y": 4,
            "z": 1
        },
        "level": 1
    },
    "gunner": {
        "affiliation": "none",
        "key": "gunner",
        "position": {
            "x": 3,
            "y": 14,
            "z": 1
        },
        "level": 1
    }
}
